import { ApolloCache, Reference } from "@apollo/client"
import { ORDER_FRAGMENT } from "../fragment/order"

export const updateCacheOrder = ({
  cache,
  entryData,
  action,
}: {
  cache: ApolloCache<any>
  entryData: any
  action: "update" | "delete" | "add"
}) => {
  return cache.modify({
    fields: {
      orders(existing = []) {
        const newOrderRef = cache.writeFragment({
          data: entryData,
          fragment: ORDER_FRAGMENT,
        })
        switch (action) {
          case "add":
            return [...existing, newOrderRef]
          case "delete":
            return [
              ...existing?.filter(
                (el: Reference | undefined) => el?.__ref !== newOrderRef?.__ref,
              ),
            ]
          case "update":
            const index = existing.findIndex(
              (el: Reference | undefined) => el?.__ref !== newOrderRef?.__ref,
            )
            const items = [...existing]
            if (index > -1) {
              items[index] = newOrderRef
            }
            return items
        }
      },
      aggregateUser(existing = {}) {
        let _all = existing?._count?._all
        switch (action) {
          case "add":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all + 1 : 0,
              },
            }
          case "delete":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all - 1 : 0,
              },
            }
        }
      },
    },
  })
}
